<template>
  <div>
    <VerifyIdentitySuccess
      v-if="displaySuccessPage"
      class="md:w-480 md:mx-auto"
    />
    <VerifyIdentityError
      v-else-if="displayErrorPage"
      class="md:w-480 md:mx-auto"
      :errorTitle="$t('mfa.modality.locked')"
      :errorBody="$t('mfa.modality.max_attempt_retry_later')"
    />
    <VerifyMfa
      v-else
      class="md:w-458 md:mx-auto"
      :codeError="displayMfaCodeError"
      :autoSendCode="true"
      :isSSORegister="isSSORegister"
      @submitMfaCode="submitMfaCode"
      @tooManySends="displayErrorPage = true"
    />
  </div>
</template>

<script>
import VerifyMfa from '../../login/VerifyMfa.vue'
import VerifyIdentitySuccess from './VerifyIdentitySuccess.vue'
import VerifyIdentityError from './VerifyIdentityError.vue'
import { TOO_MANY_CHECK_ATTEMPTS } from '@platform-shared/verify-constants.js'
import { mapActions } from 'vuex'

export default {
  components: { VerifyMfa, VerifyIdentitySuccess, VerifyIdentityError },
  props: {
    isSSORegister: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    displaySuccessPage: false,
    displayErrorPage: false,
    displayMfaCodeError: false,
  }),
  methods: {
    ...mapActions('registration', [
      'submitRegistrationMfa',
      'submitSsoRegistrationMfa',
    ]),
    submitMfaCode(totp) {
      this.mfaCodeError = false

      if (this.isSSORegister) {
        this.submitSsoRegistrationMfa(totp)
          .then(() => {
            this.displaySuccessPage = true
            setTimeout(() => {
              this.$emit('next')
            }, 3000)
          })
          .catch((e) => {
            if (e.message === TOO_MANY_CHECK_ATTEMPTS) {
              this.displayErrorPage = true
            } else {
              this.displayMfaCodeError = true
            }
          })
      } else {
        this.submitRegistrationMfa(totp)
          .then(() => {
            this.displaySuccessPage = true
            setTimeout(() => {
              this.$emit('next')
            }, 3000)
          })
          .catch((e) => {
            if (e.message === TOO_MANY_CHECK_ATTEMPTS) {
              this.displayErrorPage = true
            } else {
              this.displayMfaCodeError = true
            }
          })
      }
    },
  },
}
</script>
